import { c as _c } from "react/compiler-runtime";
import "@repo/ui/globals.css";
import "@/overrides.css";
import { ErrorBoundary } from "@repo/ui/components/ui/error-boundary";
import { AppBidcProvider } from "@/contexts/app-bidc-provider";
import { CompanyTierProvider } from "@/contexts/company-tier-context";
import { TelemetryProvider } from "@/components/telemetry-provider";
import { queryClient } from "@/lib/tanstack/query-client";
import { Toaster } from "@repo/ui/components/ui/sonner";
import { QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import type { AppProps } from "next/app";
import Head from "next/head";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { CompanySettingsProvider } from "@/contexts/company-settings";
import { IntercomWidget } from "@/components/intercom-widget";
import { WorkViewToastStyles } from "@/components/scheduler-all/event-work-view/work-view-toast-styles";
const FORCED_LIGHT_ROUTES = ["/signup", "/login", "/reset-password", "/login/forget"
// "/upgrade",
];
export default function App(t0) {
  const $ = _c(18);
  const {
    Component,
    pageProps
  } = t0;
  const router = useRouter();
  const isEmbedded = router.query.embedded === "true";
  let t1;
  let t2;
  if ($[0] !== isEmbedded) {
    t1 = () => {
      if (!isEmbedded) {
        return;
      }
      const handler = _temp;
      window.addEventListener("pageshow", handler);
      return () => window.removeEventListener("pageshow", handler);
    };
    t2 = [isEmbedded];
    $[0] = isEmbedded;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const t3 = FORCED_LIGHT_ROUTES.includes(router.pathname) ? "light" : undefined;
  let t4;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Head><title>Homeworks</title><meta name="description" content="Client portal for home service companies" /><meta name="robots" content="noindex, nofollow, noarchive, nosnippet, noimageindex" /><meta name="googlebot" content="noindex, nofollow, noarchive, nosnippet, noimageindex" /></Head>;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== Component || $[5] !== pageProps) {
    t5 = <Component {...pageProps} />;
    $[4] = Component;
    $[5] = pageProps;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IntercomWidget />;
    t7 = <WorkViewToastStyles />;
    t8 = <Toaster useCrmToastDefaults={true} />;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t6 = $[7];
    t7 = $[8];
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t5) {
    t9 = <CompanyTierProvider><CompanySettingsProvider><TelemetryProvider>{t4}<div id="__app_root"><ErrorBoundary>{t5}{t6}{t7}{t8}</ErrorBoundary></div></TelemetryProvider></CompanySettingsProvider></CompanyTierProvider>;
    $[10] = t5;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== router.pathname || $[13] !== t9) {
    t10 = <AppBidcProvider pathname={router.pathname}>{t9}</AppBidcProvider>;
    $[12] = router.pathname;
    $[13] = t9;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== t10 || $[16] !== t3) {
    t11 = <QueryClientProvider client={queryClient}><ThemeProvider attribute="class" defaultTheme="light" enableSystem={false} disableTransitionOnChange={false} forcedTheme={t3}>{t10}</ThemeProvider></QueryClientProvider>;
    $[15] = t10;
    $[16] = t3;
    $[17] = t11;
  } else {
    t11 = $[17];
  }
  return t11;
}
function _temp(e) {
  if (e.persisted) {
    window.location.reload();
  }
}